


























































import { Component, Prop, Watch } from "vue-property-decorator";
import EntityType from '@/models/Shared/EntityType';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import { CompanyDetailsModule } from '@/store/modules/companyDetails';
import { ContactDetailsModule } from '@/store/modules/contactDetails';
import { LocationDetailsModule } from '@/store/modules/locationDetails';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import { OpportunityDetailsModule } from '@/store/modules/opportunityDetails';
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import DocumentDto from "@/models/Documents/DocumentDto";
import UpdateDocumentRequest from "@/models/Documents/UpdateDocumentRequest";


@Component({
  name: "DocumentEdit",
})
export default class extends GiganautVueDialog {
  
  @Prop({required: true})
  entityType: EntityType;
  @Prop({required: true})
  document: DocumentDto;
  entity: DocumentDto = new DocumentDto();
  expiresAt = '';
  dialog = false;

  @Watch("dialog")
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(this.document));
      //Massive faff due to veutify date picker returning string not date
      if (this.entity.expiresAt !== null) {
        this.expiresAt = new Date(this.entity.expiresAt).toISOString().substr(0, 10)
      } 
    }
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    //Massive faff due to veutify date picker returning string not date
    if (this.expiresAt !== null && this.expiresAt !== '') {
      this.entity.expiresAt = new Date(this.expiresAt)
    } 
    switch (this.entityType){
        case EntityType.Booking:
            //await BookingDetailsModule.editDocument();
            break;
        case EntityType.Worker:
            await WorkerDetailsModule.editDocument(this.entity);
            break;
        case EntityType.Company:
            await CompanyDetailsModule.editDocument(this.entity);
            break;
        case EntityType.Location:
            await LocationDetailsModule.editDocument(this.entity);
            break;
        case EntityType.Opportunity:
            await OpportunityDetailsModule.editDocument(this.entity);
            break;
    }
    this.dialog = false;
  }
}
